import { useEffect, useRef, useState } from "react"

/**
 * IntersectionObserver hook that toggles a `revealed` state
 * when the element approaches the viewport. Once revealed, stays revealed.
 *
 * Uses rootMargin to trigger 150px BEFORE the element enters the viewport,
 * so animations start while the element is still below the fold.
 */
export function useRevealOnScroll(rootMargin = "0px 0px 150px 0px") {
  const ref = useRef<HTMLDivElement>(null)
  const [revealed, setRevealed] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setRevealed(true)
          observer.disconnect()
        }
      },
      { threshold: 0, rootMargin },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [rootMargin])

  return { ref, revealed }
}
